const pathsToSanitise = ["reset-password", "register", "activate"];

export const sanitisePath = (path) => {
  const foundPathToSanitise = pathsToSanitise.find(
    (pathToSanitise) => path.indexOf(pathToSanitise) > -1
  );

  if (foundPathToSanitise) {
    const pathLength = foundPathToSanitise.length;
    const pathIndex = path.indexOf(foundPathToSanitise);

    return path.slice(0, pathIndex + pathLength);
  }

  return path;
};
